module.exports = function getResource(label, vars = []) {
    let resources = { remove: 'Remove' };
    return resources[label];
};
